var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXlsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.99997L11.4545 3.45451V5.3636H5.72727V6.63633H11.4545V8.54542M0 9.81815V2.18178C0 1.47542 0.572727 0.909058 1.27273 0.909058H8.90909C9.24664 0.909058 9.57036 1.04315 9.80904 1.28183C10.0477 1.52051 10.1818 1.84424 10.1818 2.18178V4.09088H8.90909V2.18178H1.27273V9.81815H8.90909V7.90906H10.1818V9.81815C10.1818 10.1557 10.0477 10.4794 9.80904 10.7181C9.57036 10.9568 9.24664 11.0909 8.90909 11.0909H1.27273C0.935179 11.0909 0.611456 10.9568 0.372773 10.7181C0.134091 10.4794 0 10.1557 0 9.81815Z",
    fill: "#5C79AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsLogo);
export default __webpack_public_path__ + "static/media/xlsLogo.524abf697a6471dd49e95377ae8a4374.svg";
export { ForwardRef as ReactComponent };